import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: relative;
`

interface IPosition {
  top?: number
  bottom?: number
  left: number
}

const SUMMARY_HEIGHT = 75
const ELLIPSE_GROUP_BUTTON_HEIGHT = 45
const GAP = 15

const TopPositionConfig = css<IPosition>`
  position: absolute;
  left: ${({ left }) => left}px;
  top: ${({ top }) => top}px;
  transform: translate(-32%, ${-SUMMARY_HEIGHT - GAP}px);

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    width: 0;
    height: 0;
    border: 0.5rem solid transparent;
    border-top-color: ${({ theme }) => theme.zds.colors.neutral1000};
    transform: translateX(-50%);
  }
`

const BottomPositionConfig = css<IPosition>`
  position: absolute;
  left: ${({ left }) => left}px;
  bottom: ${({ bottom }) => bottom}px;
  transform: translate(-32%, ${SUMMARY_HEIGHT + ELLIPSE_GROUP_BUTTON_HEIGHT + GAP}px);

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 0;
    height: 0;
    border: 0.5rem solid transparent;
    border-bottom-color: ${({ theme }) => theme.zds.colors.neutral1000};
    transform: translateX(-50%);
  }
`

export const SummaryContainer = styled.div<IPosition>`
  ${({ top, bottom }) => {
    if (top) return TopPositionConfig
    if (bottom) return BottomPositionConfig
  }}

  padding: 1rem 0.5rem 0.7rem 0.5rem;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 0.5rem;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const EllipseGroupWrapper = styled.div``
